import { render, staticRenderFns } from "./CardLatestStatusTable.vue?vue&type=template&id=ef6e7ab0&"
import script from "./CardLatestStatusTable.vue?vue&type=script&lang=ts&"
export * from "./CardLatestStatusTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports